class Node {
  constructor(variant, variantAvailabilities) {
    this.variant = variant;
    this.variantAvailabilities = variantAvailabilities;
    this.optionsCount = this.variant.options.length;
    this.neighbors = [];

    for (let i = 0; i < this.optionsCount; i++) {
      this.neighbors.push([]);
    }
  }

  addNeighbor(variant) {
    for (let i = 0; i < this.optionsCount; i++) {
      if (this.variant.options[i] !== variant.options[i]) {
        this.neighbors[i].push(variant);
        break;
      }
    }
  }

  getValidOptions() {
    const options = [];

    for (let i = 0; i < this.optionsCount; i++) {
      const variants = [this.variant, ...this.neighbors[i]];
      options[i] = {};

      variants.forEach(item => {
        const variant = item;
        const option = variant.options[i];
        const variantAvailability = this.variantAvailabilities[variant.id];
        let variantAvailable = true;

        if (variantAvailability.online_eligible === 'no') {
          variantAvailable = false;
        } else if (
          variantAvailability.wholesale_lifecycle === 'temporary_hold'
        ) {
          variantAvailable = false;
        } else if (!variantAvailability.available) {
          variantAvailable = false;
        }

        options[i][option] = {
          available:
            (options[i][option] && options[i][option].available) ||
            variantAvailable
        };
      });
    }

    return options;
  }
}

export default class ProductOptions {
  constructor(product, variantAvailabilities) {
    this.productHandle = product.handle;
    this.optionsCount = product.options.length;
    this.variants = [];
    this.variantAvailabilities = variantAvailabilities;
    this.nodeMap = {};

    for (let i = 0; i < product.variants.length; i++) {
      const variant = product.variants[i];
      if (variant.price > 0) {
        this.variants.push(variant);
      }
    }

    this._generateNodeMap(product);
  }

  _generateNodeMap() {
    this.variants.forEach(variant => {
      if (variant.price > 0) {
        this.nodeMap[variant.id] = new Node(
          variant,
          this.variantAvailabilities
        );

        this.variants.forEach(variant2 => {
          this.nodeMap[variant.id].addNeighbor(variant2);
        });
      }
    });
  }

  getVariantFromOptions(options) {
    this.variants.forEach(variant => {
      let found = true;

      for (let i = 0; i < variant.options.length; i++) {
        if (options[i] !== variant.options[i]) {
          found = false;
        }
      }

      if (found) {
        return variant;
      }
    });

    return false;
  }

  getClosestVariantFromOptions(options) {
    let closestVariant = null;
    let matchingValues = 0;

    this.variants.forEach(variant => {
      let tempMatchingValues = 0;

      for (let i = 0; i < variant.options.length; i++) {
        if (options[i] === variant.options[i]) {
          tempMatchingValues++;
        } else {
          break;
        }
      }

      if (tempMatchingValues >= matchingValues) {
        closestVariant = variant;
        matchingValues = tempMatchingValues;
      }
    });

    return closestVariant ? closestVariant : false;
  }

  getVariantOrClosestFromOptions(options) {
    return (
      this.getVariantFromOptions(options) ||
      this.getClosestVariantFromOptions(options)
    );
  }

  getAvailableOptionsFromVariant(variant) {
    return this.nodeMap[variant.id].getValidOptions();
  }
}
